import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface ISex {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllUsualResidents?: number | null;
  male?: number | null;
  female?: number | null;
}

export const defaultValue: Readonly<ISex> = {};
